import { DiscountBannerProps } from '../../types/components/pricing/DiscountBanner';

import { ENV } from '../../constants/environments';

const DiscountBanner: React.FC<DiscountBannerProps> = ({ freeForever }) => {
  if (freeForever || ENV.displaySaleBanner !== 'true') return;

  return (
    <div cy-test-id="discount-banner" className="absolute top-0 right-0 w-full py-2 font-semibold text-center text-white bg-red-800 text-12">
      {parseInt(ENV.saleDiscountPercent)}% off yearly plans + free collection
    </div>
  );
};

export default DiscountBanner;
